import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { connect } from 'react-redux';
import { withLocalize } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { searchActions } from '../../store/searchStore';
import { isNullOrUndefined } from '../../store/storeFunctions';
import BbCheckbox from '../styling/bbCheckbox';
import PopupMultiSelectButton from '../common/popupMultiSelectButton';

class FilterSelectTree extends React.Component {
    render() {
        const isTree = this.isTree(this.props.filter.Values);
        const canCancel = this.props.filter.Values.filter(fv => this.getValue(fv.id)).length > 0;

        return (
            <div className='search-filter-content'>
                <ul className='filter-options'>
                    {isTree && this.renderTree(this.props.filter.Key, this.getTreeMe())}
                    {!isTree && this.renderFilterItems(this.props.filter.Key, this.props.filter.Name, this.props.filter.Values)}
                    {(isTree || canCancel) && (<li>{this.renderCancel(this.props.filter.Key)}</li>)}
                </ul>
            </div>
        );
    }

    renderTree = (key, me) => {
        const isPreLeaf = !isNullOrUndefined(me.children) && me.children.length > 0 && (
            (me.children.some(c => this.getValue(c.id)) && !this.isTree(me.children)) ||
            me.children.every(c => isNullOrUndefined(c.children) || c.children.length === 0)
        );

        const children = me.children.filter(c => this.getValue(c.id) || c.children.some(ch => this.getValue(ch.id)) || this.isTree(c.children));

        return (
            <>
                <li style={{ display: 'flex', paddingBottom: '.2em', fontStyle: 'italic', paddingLeft: '.5em' }}>{ReactHtmlParser(me.name)}</li>
                {children.length > 0 && !isPreLeaf ? children.map(c => this.renderTree(key, c)) : this.renderFilterItems(key, me.name, me.children)}
            </>
        )
    }

    renderFilterItems = (key, label, values) => {
        if (values === null || values === undefined)
            return null;

        const selection = isNullOrUndefined(this.props.search.searchFilter[key]) ? [] : [...this.props.search.searchFilter[key]];
        const renderAll = values.length <= 4;
        const items = renderAll ? values : values.slice(0, 4);
        return (
            <React.Fragment>
                {items.map(val => <li key={val.id}>
                    <BbCheckbox
                        label={val.name}
                        id={`${key}_${val.id}`}
                        value={this.getValue(val.id)}
                        onChange={(newVal) => this.onChange(key, newVal ? undefined : val.id, newVal ? val.id : undefined)}
                    />
                </li>)}
                {!renderAll && (<li key={`${key}_${label}`}>
                    <div style={{ flexDirection: 'row' }}>
                        <label className="input-label">
                            <div className="text" style={{ marginLeft: '1.7em', paddingLeft: '.5em' }}>...</div>
                            <span className="bb-search-filter-link" style={{ right: '.5em' }}>
                                <PopupMultiSelectButton title={label} asLink={true} data={`runtime.${key}`} popupSize={this.props.popupSize}
                                    selection={{ all: selection }}
                                    handleChange={(values) => this.onPopupChange(key, values)}
                                    linkText={this.props.translate('Search.ShowMore')} />
                            </span>
                        </label>
                    </div>
                </li>)}
            </React.Fragment>
        );
    }

    renderCancel = (key) => {
        return (
            <div style={{ flexDirection: 'row' }}>
                <label className="input-label">
                    <div className="text" style={{ marginLeft: '1.7em', paddingLeft: '.5em' }}>&nbsp;</div>
                    <span className="bb-search-filter-link" style={{ right: '.5em', cursor: 'pointer' }} onClick={() => this.cancelSelection(key)}>
                        {this.props.translate('Common.Button.Cancel')}
                    </span>
                </label>
            </div>
        );
    }

    isTree = (values) => {
        //reject empty and undefined arrays
        if (isNullOrUndefined(values) || values.length < 1)
            return false;
        //accept individual checked leaves
        if (values.length === 1 && this.getValue(values[0].id))
            return true;
        //accept nodes that have at least one checked child; recurse for children
        return values.filter(v => this.getValue(v.id) && !isNullOrUndefined(v.children)).length > 0;
    }

    getTreeMe = () => {
        const sf0 = this.props.search.searchFilter[this.props.filter.Key][0];
        let foundIndex = this.props.filter.Values.findIndex(item => (item.id === sf0) );
        if (foundIndex === -1)
            foundIndex = 0;
        return this.props.filter.Values[foundIndex];
    }

    onPopupChange = (key, values) => {
        this.props.setSearchFilter(key, values.map(x => x.value));
    }

    onChange = (key, oldVal, newVal) => {
        let selected = this.props.search.searchFilter[key] || [];
        if (Array.isArray(newVal))
            selected = newVal;
        else {
            if (oldVal === undefined)
                selected.push(newVal);
            else if (newVal === undefined)
                selected.pop(oldVal);
        }
        this.props.setSearchFilter(key, selected);
    }

    cancelSelection = (key) => {
        this.props.setSearchFilter(key, []);
    }

    getValue = (cbKey) => {
        const key = this.props.filter.Key;
        if (isNullOrUndefined(this.props.search.searchFilter[key]) || !Array.isArray(this.props.search.searchFilter[key]))
            return false;
        return this.props.search.searchFilter[key].includes(cbKey);
    }
}

export default withLocalize(connect(
    state => ({ search: state.search }),
    dispatch => bindActionCreators(searchActions, dispatch),
)(FilterSelectTree));